import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";

const RadioField = forwardRef((props, ref) => {
  const {
    error,
    className,
    title,
    caption,
    options,
    value,
    onChange,
    name,
    required,
    readOnly,
    forbidChange,
    ..._props
  } = props;

  return (
    <div className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
            [styles.forbidChange]: forbidChange,
          })}
        >
          {title}
        </legend>
      )}
      <div className={styles.formGroup}>
        {options.map((option, i) => (
          <div
            className={classnames(styles.inputField, styles.radio, {
              [styles.readOnly]: readOnly,
            })}
            key={`radio-${i}`}
          >
            <input
              ref={ref}
              type="radio"
              name={name}
              id={`${name}-${option.value}`}
              className={classnames(styles.radioInput, className)}
              value={option.value}
              onChange={() => onChange(option.value)}
              checked={value === option.value}
              {..._props}
            />
            <label htmlFor={`${name}-${option.value}`} tabIndex="0">
              {option.label}
            </label>
          </div>
        ))}
      </div>
      {caption && <p className={styles.caption}>{caption}</p>}
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
});

RadioField.displayName = "RadioField";
export default RadioField;
